import { render } from "./BottomNavigationBar.vue?vue&type=template&id=73da6f42"
import script from "./BottomNavigationBar.vue?vue&type=script&lang=js"
export * from "./BottomNavigationBar.vue?vue&type=script&lang=js"

import "./BottomNavigationBar.vue?vue&type=style&index=0&id=73da6f42&lang=scss"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__